import axios from 'axios'

const StudentService = {
  async getList (params = {}) {
    return axios.get('admin/students', { params })
  },

  async show (id) {
    return axios.get(`admin/students/${id}`)
  },

  async store (data) {
    return axios.post('admin/students', data)
  },

  async update (id, data) {
    return axios.put(`admin/students/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/students/${id}`)
  },

  async updateStatus (id, data) {
    return axios.patch(`admin/students/${id}/status`, data)
  }
}

export default StudentService
